import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { drawerWidth } from '../../../store/constant';

// helper to get role
const getUserRole = () => {
  try {
    const userData =
      sessionStorage.getItem('cookiesData') ||
      localStorage.getItem('cookiesData');

    if (!userData) return 'default';

    const data = userData.split('-');
    return data[1]; // role
  } catch (err) {
    return 'default';
  }
};

// ROLE BASED THEMES
const roleThemes = {
  superadmin: {
    gradient: '#0F172A',

  },
  stateadmin: {
    gradient: '#064E3B',

  },
  dealer: {
    gradient: '#7C2D12',

  },
  devicemanufacture: {
    gradient: '#1F2937',

  },
  esimprovider: {
    gradient: '#7F1D1D',

  },
  default: {
    gradient: '#111827',

  }
};


// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));


  const role = getUserRole();
  const currentTheme = roleThemes[role] || roleThemes.default;
    const handleMenuClick = () => {
    drawerToggle(false);
  };

  const drawer = (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Box sx={{ display: 'flex', p: 0, mx: 0 }}>
          <LogoSection />
        </Box>
      </Box>
      <PerfectScrollbar
        component="div"
        style={{
          height: !matchUpMd ? 'calc(100vh - 130px)' : 'calc(100vh - 70px)',
          paddingLeft: '16px',
          paddingRight: '16px'
        }}
      >
        <MenuList  onMenuClick={handleMenuClick} />
      </PerfectScrollbar>
      {/* <MobileView>
        <Box sx={{ px: 2 }}>
          <MenuList />
        </Box>
      </MobileView> */}
    </>
  );

  const container = window !== undefined ? () => window.document.body : undefined;



  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
      <Drawer
        container={container}
        variant={matchUpMd ? 'persistent' : 'temporary'}
        anchor="top"
//         slotProps={{
//   backdrop: {
//     invisible: true, // ✅ completely removes blur/overlay
//     sx: {
//       backgroundColor: 'transparent !important',
//       backdropFilter: 'none !important'
//     }
//   }
// }}
        open={drawerOpen}
        onClose={() => drawerToggle(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: '220px',
            display: 'flex',
            flexDirection: 'column',
            //  ROLE BASED BACKGROUND
            background: currentTheme.gradient,
            position: 'fixed',
            overflow: 'hidden',
            color: "#ffffff",
            '& *': {
              color: "#ffffff !important",
            },
            zIndex: 1300,


            transition: 'all 0.3s ease',

            boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
            borderRight: '1px solid rgba(255,255,255,0.05)',


            [theme.breakpoints.up('md')]: {
              top: '65px',
              bottom: '60px', // 👈 footer height (adjust if needed)
              height: 'auto',
            },
            [theme.breakpoints.down('md')]: {
              position: 'fixed',
              top: 0,
              left: 0,
              width: '220px',        // 👈 FULL WIDTH
              height: 'auto',
              bottom: '60px',
              borderRadius: '0 0 12px 12px', // 👈 smooth bottom

            }
          },
          '& .MuiBackdrop-root': {
      display: 'none' // Forcefully hide the backdrop element
    }
          
        }}
        ModalProps={{
          keepMounted: true,
          disableScrollLock: true,
          disableEnforceFocus: true,
          disableAutoFocus: true,
          hideBackdrop: true,
           onBackdropClick: () => drawerToggle(false)
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default Sidebar;
